var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 100,
    viewBox: "0 0 127 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "url(#paint0_linear_4834_3061)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4834_3061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 22.668H117.333C118.217 22.668 119.065 23.0192 119.69 23.6443C120.315 24.2694 120.667 25.1172 120.667 26.0013V42.668C120.667 43.552 120.315 44.3999 119.69 45.025C119.065 45.6501 118.217 46.0013 117.333 46.0013H27.3333C26.4493 46.0013 25.6014 45.6501 24.9763 45.025C24.3512 44.3999 24 43.552 24 42.668V26.0013C24 25.1172 24.3512 24.2694 24.9763 23.6443C25.6014 23.0192 26.4493 22.668 27.3333 22.668V22.668Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9974 28H52.6641C51.5595 28 50.6641 28.8954 50.6641 30C50.6641 31.1046 51.5595 32 52.6641 32H69.9974C71.102 32 71.9974 31.1046 71.9974 30C71.9974 28.8954 71.102 28 69.9974 28Z",
    fill: "#B4DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9974 36.666H52.6641C51.5595 36.666 50.6641 37.5614 50.6641 38.666C50.6641 39.7706 51.5595 40.666 52.6641 40.666H81.9974C83.102 40.666 83.9974 39.7706 83.9974 38.666C83.9974 37.5614 83.102 36.666 81.9974 36.666Z",
    fill: "#DEE9FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 34.3346C45.3333 28.9959 41.0054 24.668 35.6667 24.668C30.3279 24.668 26 28.9959 26 34.3346C26 39.6734 30.3279 44.0013 35.6667 44.0013C41.0054 44.0013 45.3333 39.6734 45.3333 34.3346Z",
    fill: "#1485FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0684 37.4631C35.896 37.463 36.6997 37.1861 37.3518 36.6764L39.4018 38.7264L40.0611 38.0671L38.0104 36.0164C38.5256 35.3503 38.8001 34.5293 38.7889 33.6873C38.7778 32.8452 38.4819 32.0317 37.9492 31.3794C37.4166 30.7271 36.6788 30.2745 35.856 30.0952C35.0331 29.9159 34.1739 30.0206 33.4182 30.3922C32.6625 30.7638 32.0549 31.3804 31.6945 32.1415C31.3341 32.9026 31.2421 33.7634 31.4335 34.5834C31.6249 35.4035 32.0884 36.1346 32.7485 36.6575C33.4086 37.1805 34.2263 37.4644 35.0684 37.4631ZM35.0684 30.9338C35.6222 30.9338 36.1636 31.098 36.624 31.4057C37.0845 31.7133 37.4434 32.1506 37.6553 32.6623C37.8672 33.1739 37.9227 33.7369 37.8146 34.28C37.7066 34.8232 37.4399 35.3221 37.0483 35.7137C36.6567 36.1053 36.1578 36.3719 35.6147 36.48C35.0715 36.588 34.5086 36.5326 33.9969 36.3206C33.4853 36.1087 33.048 35.7498 32.7403 35.2894C32.4326 34.8289 32.2684 34.2876 32.2684 33.7338C32.2684 32.9912 32.5634 32.279 33.0885 31.7539C33.6136 31.2288 34.3258 30.9338 35.0684 30.9338Z",
    fill: "#1485FD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4834_3061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.333 52.668H17.3333C15.4924 52.668 14 54.1604 14 56.0013V72.668C14 74.5089 15.4924 76.0013 17.3333 76.0013H107.333C109.174 76.0013 110.667 74.5089 110.667 72.668V56.0013C110.667 54.1604 109.174 52.668 107.333 52.668Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9974 58H42.6641C41.5595 58 40.6641 58.8954 40.6641 60C40.6641 61.1046 41.5595 62 42.6641 62H59.9974C61.102 62 61.9974 61.1046 61.9974 60C61.9974 58.8954 61.102 58 59.9974 58Z",
    fill: "#B4DAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9974 66.666H42.6641C41.5595 66.666 40.6641 67.5614 40.6641 68.666C40.6641 69.7706 41.5595 70.666 42.6641 70.666H71.9974C73.102 70.666 73.9974 69.7706 73.9974 68.666C73.9974 67.5614 73.102 66.666 71.9974 66.666Z",
    fill: "#DEE9FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3333 64.3346C35.3333 58.9959 31.0054 54.668 25.6667 54.668C20.3279 54.668 16 58.9959 16 64.3346C16 69.6734 20.3279 74.0013 25.6667 74.0013C31.0054 74.0013 35.3333 69.6734 35.3333 64.3346Z",
    fill: "#1485FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0684 67.4631C25.896 67.463 26.6997 67.1861 27.3518 66.6764L29.4018 68.7264L30.0611 68.0671L28.0104 66.0164C28.5256 65.3503 28.8001 64.5293 28.7889 63.6873C28.7778 62.8452 28.4819 62.0317 27.9492 61.3794C27.4166 60.7271 26.6788 60.2745 25.856 60.0952C25.0331 59.9159 24.1739 60.0206 23.4182 60.3922C22.6625 60.7638 22.0549 61.3804 21.6945 62.1415C21.3341 62.9026 21.2421 63.7634 21.4335 64.5834C21.6249 65.4035 22.0884 66.1346 22.7485 66.6575C23.4086 67.1805 24.2263 67.4644 25.0684 67.4631ZM25.0684 60.9338C25.6222 60.9338 26.1636 61.098 26.624 61.4057C27.0845 61.7133 27.4434 62.1506 27.6553 62.6623C27.8672 63.1739 27.9227 63.7369 27.8146 64.28C27.7066 64.8232 27.4399 65.3221 27.0483 65.7137C26.6567 66.1053 26.1578 66.3719 25.6147 66.48C25.0715 66.588 24.5086 66.5326 23.9969 66.3206C23.4853 66.1087 23.048 65.7498 22.7403 65.2894C22.4326 64.8289 22.2684 64.2876 22.2684 63.7338C22.2684 62.9912 22.5634 62.279 23.0885 61.7539C23.6136 61.2288 24.3258 60.9338 25.0684 60.9338Z",
    fill: "#1485FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4834_3061",
    x: 18,
    y: 19.668,
    width: 108.668,
    height: 35.334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4834_3061"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4834_3061",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4834_3061",
    x: 8,
    y: 49.668,
    width: 108.668,
    height: 35.334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4834_3061"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4834_3061",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4834_3061",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDashboardIcon);
export default __webpack_public_path__ + "static/media/emptyDashboardIcon.45ea4a582b0c3a32ce343fe6a7b94da2.svg";
export { ForwardRef as ReactComponent };